import "./FellingAndRoots.module.css";
import Header from "@/reusable_sections/Header";
import SpecializedServices from "./sections/SpecializedServices";
import DescubreElCatalogo from "./sections/DescubreElCatalogo";
import BasDePageOsteomed from "@/reusable_sections/Footer";
export default function FellingAndRootsPage() {
  return <div>
      <Header />
      <SpecializedServices />
      <DescubreElCatalogo />
      <BasDePageOsteomed />
    </div>;
}